import ProjectEditorForm from '@/views/kpi/kpi-build/project/project-editor-form.vue';
export const useProjectEditorModal = () => {
  const {
    openEditor
  } = useComponentModal();
  const showProjectEditorModal = async (title, projId) => {
    return openEditor(title, ProjectEditorForm, {
      projId
    }, {
      width: '70%',
      showMaximize: false,
      showMinimize: false
    });
  };
  return {
    showProjectEditorModal
  };
};